export default __webpack_public_path__ + "static/media/f_iconlist.e18c2ed0.svg";